module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';

if(!_.size(attributes)){
    print("<p>" + lang.NO_RESULTS + "</p>");
} else {

  

__p+='\r\n    <table id="mainData" class="reportsTable">\r\n        <thead>\r\n            ';

  
	if(type==="epigrafes"){
 
	
__p+='\r\n\r\n                <tr>\r\n                    <th class="wid_10">\r\n                        '+
((__t=(lang["CODIGO"]))==null?'':_.escape(__t))+
'\r\n                    </th>\r\n                    <th class="wid_50">\r\n                        '+
((__t=(lang["NAME"]))==null?'':_.escape(__t))+
'\r\n                    </th>\r\n                    <th class="wid_20">\r\n                        '+
((__t=(lang["DESCRIPTIVOS_CANTIDAD"]))==null?'':_.escape(__t))+
'\r\n                    </th>\r\n\r\n                    <th class="wid_20">\r\n                        '+
((__t=(lang["REPEPIG_INVENTA"]))==null?'':_.escape(__t))+
'\r\n                    </th>\r\n\r\n                </tr>\r\n                ';

	}else{
 
		
	
__p+='\r\n                    <tr>\r\n                        <th class="wid_10">\r\n                            '+
((__t=(lang["CODIGO"]))==null?'':_.escape(__t))+
'\r\n                        </th>\r\n                        <th class="wid_40">\r\n                            '+
((__t=(lang["NAME"]))==null?'':_.escape(__t))+
'\r\n                        </th>\r\n                        <th class="wid_5">\r\n                            '+
((__t=(lang["DESCRIPTIVOS_CANTIDAD"]))==null?'':_.escape(__t))+
'\r\n                        </th>\r\n\r\n                        <th class="wid_15">\r\n                            '+
((__t=(lang["RE_TOTALDEBE"]))==null?'':_.escape(__t))+
'\r\n                        </th>\r\n                        <th class="noneindate wid_15  ">\r\n                            '+
((__t=(lang["REP_TOTALPATRINETO"]))==null?'':_.escape(__t))+
'\r\n                        </th>\r\n                        <th class="noneindate wid_15 ">\r\n                            '+
((__t=(lang["REP_TOTALHABER"]))==null?'':_.escape(__t))+
'\r\n                        </th>\r\n                    </tr>\r\n                    ';

	}
	
__p+='\r\n        </thead>\r\n        <tbody>\r\n            ';

	if(type==="epigrafes"){
		_.each(attributes.goods, function(good){

            
            
			print("<tr>" +
			'<td>' + good.code + '</td>' +
			'<td>' + good.translation + '</td>' +
			'<td class="text-left">' + good.bienes + '</td>' +
            '<td class="text-left">' + good.costeTotal + '</td>' + 
			"</tr>");
		});
	}else{
		_.each(attributes.goods, function(good){
            
             
            
			print("<tr>" +
            <!--'<td>' + cuentas[good.economicos_cuenta] + '</td>' +-->
			'<td>' + good.code + '</td>' +
			'<td>' + good.translation + '</td>' +
			'<td class="text-left">' + good.bienes + '</td>' +
		 
			'<td class="text-left">' + good.costeTotal + '</td>' +
			'<td class="text-left noneindate">' + good.vncTotal + '</td>' +
			'<td class="text-left noneindate">' + good.amortiAcumuTotal + '</td>' +
			"</tr>");
        });
        
        print ("<tr><td colspan=6><b size=4> EN CURSO </b></td></tr>");

        
        _.each(attributes.curso, function(good){
            
             
           
			print("<tr>" +
            <!--'<td>' + cuentas[good.economicos_cuenta] + '</td>' +-->
			'<td>' + good.code + '</td>' +
			'<td>' + good.translation + '</td>' +
			'<td class="text-left">' + good.bienes + '</td>' +
		 
			'<td class="text-left">' + good.costeTotal + '</td>' +
			'<td class="text-left noneindate">' + good.vncTotal + '</td>' +
			'<td class="text-left  noneindate">' + good.amortiAcumuTotal + '</td>' +
			"</tr>");
		});
	}
	
__p+='\r\n        </tbody>\r\n        <tfoot>\r\n            ';

	var totales = attributes.totales;
 
    
	if(type==="epigrafes"){
		print("<tr>" +
		'<td><b>Total General</b></td>' +
		'<td></td>' +
		'<td class="text-left"><b>' + totales.totalBienes + '</b></td>' +
	 
		<!--'<td class="text-left"><b>' + totales.totalPatrimonio + '</b></td>' + -->
        '<td class="text-left"><b>' + totales.totalPatrimonio + '</b></td>' + 
		"</tr>");
	}else{
		print("<tr>" +
		'<td colspan="2"><b>Total General</b></td>' +
		'<td class="text-left"><b>' + totales.totalBienes + '</b></td>' +
	 
		'<td class="text-left"><b>' + totales.totalPatrimonio + '</b></td>' +
		'<td class="text-left  noneindate"><b>' + totales.totalVNC + '</b></td>' +
		'<td class="text-left noneindate"><b>' + totales.totalAmortizatotal + '</b></td>' +
		"</tr>");
	}
	
__p+='\r\n        </tfoot>\r\n    </table>\r\n    <div id="paginationHolder"></div>\r\n    ';
 } 
__p+='';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/report/regionResumenView.ejs
// module id = 448
// module chunks = 0